<script setup>
const emit = defineEmits(['submit'])
const props = defineProps({
  priceInfo: {
    type: Object,
    required: true,
    default: {}
  }
})

const cms = useCms()
const common = cms.value?.common
const screenType = useScreenType()

const inludeModal = ref(false)

const onClickIncluded = () => {
  inludeModal.value = true
}
</script>

<template>
  <div class="w-full desktop:w-[336px]">
    <div
      v-if="$route?.name == 'checkout' && screenType != 'mobile'"
      class="w-full desktop:w-[336px]"
    >
      <SearchPromotion></SearchPromotion>
    </div>
    <!-- <div
      v-else
      class="w-full mb-4 desktop:w-[336px] py-3 px-6 bg-white rounded-[10px]"
    >
      <Social></Social>
    </div> -->
    <div class="desktop:w-[336px]">
      <PriceBoxPaymentInfo
        v-if="screenType == 'desktop'"
        :priceInfo="priceInfo"
        @submit="$emit('submit')"
        @clickIncluded="onClickIncluded"
      ></PriceBoxPaymentInfo>
      <PriceBoxPaymentInfoMobile
        v-else="!screenType == 'desktop'"
        :priceInfo="priceInfo"
        @submit="$emit('submit')"
        @clickIncluded="onClickIncluded"
      ></PriceBoxPaymentInfoMobile>
    </div>

    <!-- <PriceBoxWhyInfo></PriceBoxWhyInfo> -->
    <Modal :open="inludeModal">
      <div
        class="h-full flex justify-center items-center max-w-[1040px] w-screen tablet:mx-10"
      >
        <div class="bg-white w-full max-w-[640px] p-6 rounded-[10px]">
          <div class="flex justify-between">
            <h2
              cms-key="included_in_price"
              class="text-ui-secondary text-xl font-bold"
            >
              {{ common?.included_in_price }}
            </h2>
            <i
              class="icon-close cursor-pointer"
              @click="inludeModal = false"
            ></i>
          </div>
          <ul class="font-semibold text-ui-secondary pt-4 divide-y">
            <li
              class="flex gap-x-4 items-center py-3"
              v-for="item in priceInfo?.includedCoverages"
              :key="item"
              :cms-key="`included_${item}`"
            >
              <i class="icon-check-basic text-[24px] text-main-secondary"></i>
              {{ common[`included_${item}`] || item }}
            </li>
          </ul>
        </div>
      </div>
    </Modal>
  </div>
</template>

<style lang="scss" scoped></style>
